import FormControl from '@/components/FormControl/FormControl';
import { useAppDispatch } from '@/store/hooks';
import type { RootState } from '@/store/rootReducer';
import { getOrderSettings, setOrderSettings } from '@/store/slices/orderSlice';
import React, { useCallback, useEffect } from 'react'
import { useForm } from 'react-hook-form';
import toast from '@/lib/toast';
import { useSelector } from 'react-redux';
import { ButtonLoader } from '@/components/Loader/ButtonLoader';

type FormValues = {
  AutoMarkVisitAsProductive: boolean;
  OrderEditDurationInDays: number;
};

const OrderSetting: React.FC = () => {
  const dispatch = useAppDispatch();

  const { orderSettings, loading } = useSelector(
    (state: RootState) => state.orders
  );

  const { control, reset, getValues } = useForm<FormValues>({
    mode: "onChange",
    defaultValues: {
      AutoMarkVisitAsProductive: false,
      OrderEditDurationInDays: 0,
    },
  });

  const fetchOrderSettings = useCallback(() => {
    dispatch(getOrderSettings());
  }, [dispatch]);

  useEffect(() => {
    fetchOrderSettings();
  }, [fetchOrderSettings]);

  useEffect(() => {
    if (orderSettings) {
      reset({
        AutoMarkVisitAsProductive: orderSettings.AutoMarkVisitAsProductive,
        OrderEditDurationInDays: orderSettings.OrderEditDurationInDays,
      });
    }
  }, [orderSettings, reset]);

  const handleSave = () => {
    const values = getValues();

    dispatch(setOrderSettings(values))
      .unwrap()
      .then(() => {
        toast.success("Order Settings Saved Successfully");
      })
      .catch((err) => toast.error(err));
  };

  return (
    <div className="min-h-screen flex justify-center pt-20">
      <div className="w-full max-w-2xl space-y-9">

        <div className="grid grid-cols-2 items-center gap-4">
          <p className="text-gray-600 font-semibold">
            Auto Mark Visit As Productive
          </p>

          <FormControl
            name="AutoMarkVisitAsProductive"
            controlType="toggle"
            control={control}
          />
        </div>

        <div className="grid grid-cols-2 items-center gap-4">
          <p className="text-gray-600 font-semibold">
            Order Edit Duration In Days
          </p>

          <FormControl
            name="OrderEditDurationInDays"
            controlType="input"
            type="number"
            control={control}
          />
        </div>

        <ButtonLoader
        loading={loading.OrderSetting}
          variant="contained"
          onClick={() => handleSave()}
        >
          Save
        </ButtonLoader>

      </div>
    </div>
  );

}

export default OrderSetting